<template>
    <div class="container-fluid__with-padding-x">
        <div class="row">
            <!-- documents -->
                <div class="col-md-6 col-12" v-if="data.documents && data.documents.length">
                    <div class="separator margin_bottom_60">{{ $t('page.documents')}}</div>
                <div v-for="document in data.documents">
                    <a
                        v-if="document"
                        :href="document.url"
                        class="btn btn-outline-primary btn-file !inline-flex items-center gap-1" target="_blank">{{ document.title }}
                        <file-outline-icon :size="16"/></a>
                </div>
                <div class="margin_bottom_60"></div>
            </div>
            <!-- links -->
            <div class="col-md-6 col-12" v-if="data.website || data.facebook || data.instagram">
                <div class="separator margin_bottom_60">{{ $t('page.links')}}</div>
                <div v-if="data.website">
                    <a :href="addHttp(data.website)" class="btn btn-outline-primary btn-file !inline-flex items-center gap-1" target="_blank">{{ $t('page.website')}}
                        <launch-icon :size="16"/></a>
                </div>
                <div v-if="data.facebook">
                    <a :href="addHttp(data.facebook)" class="btn btn-outline-primary btn-file !inline-flex items-center gap-1" target="_blank">{{ $t('page.facebook')}}
                        <launch-icon :size="16"/></a>
                </div>
                <div v-if="data.instagram">
                    <a :href="addHttp(data.instagram)" class="btn btn-outline-primary btn-file !inline-flex items-center gap-1" target="_blank">{{ $t('page.instagram')}}
                        <launch-icon :size="16"/></a>
                </div>
                <div class="margin_bottom_60"></div>
            </div>
            <!-- credits -->
            <div class="col-md-6 col-12" v-if="data.credits">
                <div class="separator margin_bottom_60">{{ $t('page.credits')}}</div>
                <div class="margin_bottom_60 unica-20" v-html="compiledMarkdown"></div>
            </div>
            <!-- producers -->
            <div class="col-md-6 col-12" v-if="data.producers && data.producers.length">
                <div class="separator margin_bottom_60">{{ $t('page.producers')}}</div>
                <div class="row ">
                    <div class="col-4 col-md-3  partners" v-for="producer in data.producers">
                        <a :href="addHttp(producer.url)" target="_blank" >
                            <img v-if="producer.logo" class="img-fluid" :src="producer.logo" :alt="producer.name + ' logo'"/>
                            <div v-else class="unica-20">{{ producer.name }}</div>
                        </a>
                    </div>
                </div>
                <div class="margin_bottom_60"></div>
            </div>
            <!-- partners -->
            <div class="col-md-6 col-12" v-if="data.partners && data.partners.length">
                <div class="separator margin_bottom_60">{{ $t('page.partners')}}</div>
                <div class="row ">
                    <div class="col-4 col-md-3  partners" v-for="partner in data.partners">
                        <a :href="addHttp(partner.url)" target="_blank" >
                            <img v-if="partner.logo" class="img-fluid" :src="partner.logo" :alt="partner.name + ' logo'"/>
                            <div v-else class="unica-20">{{ partner.name }}</div>
                        </a>
                    </div>
                </div>
                <div class="margin_bottom_60"></div>
            </div>
        </div>
    </div>

</template>

<script>
    import prependHttp from "prepend-http";
    import FileOutlineIcon from "vue-material-design-icons/FileOutline";
    import LaunchIcon from "vue-material-design-icons/Launch";
    import marked from "marked";

    export default {
        name: "DetailedInfo",
        components: {
            FileOutlineIcon,
            LaunchIcon,
        },
        props: {
            data : null
        },
        methods: {
            addHttp(url) {
                if (url) {
                    return prependHttp(url);
                }
            }
        },
        computed: {
            compiledMarkdown () {
                if (this.data.credits) {
                    return marked(this.data.credits, {sanitize: true});
                }
            }
        },
    }
</script>

